import { ABORT_ERROR_SIGNATURES } from '@/domains/common/abort';
import { initPostHog } from '@/external/posthog/client';
import * as Sentry from '@sentry/nextjs';

// Next throws this (error E394) when a Server Action's POST comes back with
// anything other than `content-type: text/x-component` — a load-balancer error
// page during a deploy, a redirect to sign-in, or a tampered request. The tab
// has no action to take and neither do we; the server-side cause reports
// itself where it happens.
const NON_RSC_ACTION_RESPONSE = 'An unexpected response was received from the server.';

// NEXT_PUBLIC_* vars are statically inlined by Next.js at build time —
// settings.ts is server-only, so we have to read process.env directly here.
const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENV ?? 'unknown',
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    ignoreErrors: [...ABORT_ERROR_SIGNATURES, NON_RSC_ACTION_RESPONSE],
  });
}

initPostHog();

// Required so Next.js can report client-side navigation timings to Sentry.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
